import React from 'react';
import { Mutation } from '@apollo/client/react/components';

import RequestIdeaUpdateMutation from 'buyside/graphql/mutations/RequestIdeaUpdate';

import RequestUpdateModal from 'buyside/components/presentation/IdeaShowPage/RequestUpdateModal/requestUpdateModal';

const RequestUpdateModalContainer = props => (
  <Mutation mutation={RequestIdeaUpdateMutation}>
    {mutate => {
      const requestIdeaUpdate = ({ body, ideaId }) => mutate({ variables: { body, ideaId } });
      return <RequestUpdateModal {...props} requestIdeaUpdate={requestIdeaUpdate} />;
    }}
  </Mutation>
);

export default RequestUpdateModalContainer;
